import { trpc } from '@/shared/api';

/** 어드민 결제 상세(paymentManagement.get) — 환불 이력을 함께 준다. */
export const usePaymentDetailQuery = (id: string) => trpc.paymentManagement.get.useQuery({ id });
